import { useEffect, useState } from 'react';

const STEPS = [
  'Reading session transcript…',
  'Cross-referencing pinned key moments…',
  'Checking math and policy constraints…',
  'Drafting sections: repayment, fee waiver, lease renewal…',
  'Assembling signable document…',
];

/**
 * Fills the agreement tab while the LLM is drafting — gives the mediator
 * something to watch during the ~10-20 seconds of Anthropic round-trip
 * latency.
 */
export function AgreementGeneratingOverlay() {
  const [stepIdx, setStepIdx] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setStepIdx((i) => (i + 1 < STEPS.length ? i + 1 : i));
    }, 1800);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-6 text-center">
      <div className="flex items-center gap-2">
        <span
          className="inline-block h-3 w-3 animate-pulse rounded-full bg-brand"
          aria-hidden
        />
        <span className="text-sm font-semibold text-gray-800">Generating agreement</span>
      </div>
      <ol className="w-full max-w-xs space-y-1.5 text-left text-xs">
        {STEPS.map((step, i) => {
          const done = i < stepIdx;
          const active = i === stepIdx;
          return (
            <li
              key={i}
              className={[
                'flex items-center gap-2 rounded-md px-2 py-1 transition-colors',
                active ? 'bg-brand-subtle text-gray-900' : '',
                done ? 'text-gray-500' : '',
                !done && !active ? 'text-gray-400' : '',
              ].join(' ')}
            >
              <span aria-hidden className="w-4 shrink-0 text-center">
                {done ? '✓' : active ? '…' : '·'}
              </span>
              <span>{step}</span>
            </li>
          );
        })}
      </ol>
      <p className="max-w-xs text-[11px] text-gray-500">
        Drafting a full agreement from the session. This usually takes 10–20 seconds.
      </p>
    </div>
  );
}
